import { useState } from "react";
import styles from "./borrowingCapacity.module.css";
import BorrowingCapacityResult from "./borrowingCapacityResult";
import BorrowingCapacityApllicantInfo1 from "./borrowingCapacityApllicantInfo1";
import BorrowingCapacityApllicantInfo2 from "./borrowingCapacityApllicantInfo2";

const BorrowingCapacity = () => {
  const [numberOfApplicants, setNumberOfApplicants] = useState(1);
  const [numberOfDependant, setNumberOfDependant] = useState(0);
  const [annualIncome1, setAnnualIncome1] = useState(0);
  const [annualIncome2, setAnnualIncome2] = useState(0);
  const [monthlyRentalIncome, setMonthlyRentalIncome] = useState(0);
  const [creditCardLimit, setCreditCardLimit] = useState(0);
  const [personalLoanRepay, setPersonalLoanRepay] = useState(0);
  const [homeLoanRepay, setHomeLoanRepay] = useState(0);
  const [rate, setRate] = useState(6.5);
  const [year, setYear] = useState(30);
  const [serviceBuffer, setServiceBuffer] = useState(3);
  const [displayPart, setDisplayPart] = useState(1);

  const dependants = Array.from({ length: 11 }, (_, index) => index);
  const years = Array.from({ length: 30 }, (_, index) => index + 1);

  const onNumberOfApplicantsChange = (applicants) => {
    setNumberOfApplicants(applicants);
  };

  const onNumberOfDependantChange = (numberOfDep) => {
    setNumberOfDependant(numberOfDep);
  };

  const onRateChange = (rateChanged) => {
    setRate(rateChanged);
  };

  const onYearsChange = (yearsChanged) => {
    setYear(yearsChanged);
  };

  const onAnnualIncome1 = (newValue) => {
    setAnnualIncome1(newValue);
  };

  const onAnnualIncome2 = (newValue) => {
    setAnnualIncome2(newValue);
  };

  const onCreditCardChange = (newValue) => {
    setCreditCardLimit(newValue);
  };

  const onHomeLoanRepayChange = (newValue) => {
    setHomeLoanRepay(newValue);
  };

  const onRentalIncomeChange = (newValue) => {
    setMonthlyRentalIncome(newValue);
  };

  const onPersonalLoanChange = (newValue) => {
    setPersonalLoanRepay(newValue);
  };

  const setDisplayPartChange = (part) => {
    setDisplayPart(part);
  };

  return (
    <>
      <div className={`row g-6 ${styles.main_wrapper}`}>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          {displayPart === 1 && (
            <BorrowingCapacityApllicantInfo1
              numberOfApplicants={numberOfApplicants}
              onNumberOfApplicantsChange={onNumberOfApplicantsChange}
              numberOfDependant={numberOfDependant}
              dependants={dependants}
              onNumberOfDependantChange={onNumberOfDependantChange}
              rate={rate}
              onRateChange={onRateChange}
              year={year}
              years={years}
              onYearsChange={onYearsChange}
              annualIncome1={annualIncome1}
              annualIncome2={annualIncome2}
              onAnnualIncome1={onAnnualIncome1}
              onAnnualIncome2={onAnnualIncome2}
            />
          )}
          {displayPart === 2 && (
            <BorrowingCapacityApllicantInfo2
              creditCardLimit={creditCardLimit}
              onCreditCardChange={onCreditCardChange}
              homeLoanRepay={homeLoanRepay}
              onHomeLoanRepayChange={onHomeLoanRepayChange}
              monthlyRentalIncome={monthlyRentalIncome}
              onRentalIncomeChange={onRentalIncomeChange}
              personalLoanRepay={personalLoanRepay}
              onPersonalLoanChange={onPersonalLoanChange}
            />
          )}
          <div
            className={`col-m-6 ${
              displayPart === 1
                ? styles.btn_next_wrapper_end
                : styles.btn_next_wrapper_start
            }`}
          >
            <button
              className={`btn btn-secondary ${styles.btn_next}`}
              onClick={() => setDisplayPartChange(1)}
              hidden={displayPart === 1}
            >
              Back
            </button>
            <button
              className={`btn btn-secondary ${styles.btn_next}`}
              onClick={() => setDisplayPartChange(2)}
              hidden={displayPart === 2}
            >
              Next
            </button>
          </div>
        </div>
        <div className={`row g-3 ${styles.data_wrapper}`}>
          <BorrowingCapacityResult
            numberOfApplicantsIn={numberOfApplicants}
            numberOfDependantIn={numberOfDependant}
            annualIncome1In={annualIncome1}
            annualIncome2In={annualIncome2}
            monthlyRentalIncomeIn={monthlyRentalIncome}
            creditCardLimitIn={creditCardLimit}
            personalLoanRepayIn={personalLoanRepay}
            homeLoanRepayIn={homeLoanRepay}
            yearIn={year}
            rateIn={rate}
            serviceBufferIn={serviceBuffer}
          />
        </div>
      </div>
    </>
  );
};

export default BorrowingCapacity;
